class DZModelOther{

    /**
     * 主键
     */
    id = "";

    /**
     * 土地信息ID
     */
    landId = "";

    /**
     *电力设施
     */
    power = "";

    /**
     *供水
     */
    water = "";

    /**
     *供热
     */
    heating = "";

    /**
     *能源
     */
    energy = "";

    /**
     *通讯
     */
    communicate = "";

    /**
     *电视系统
     */
    television = "";

    /**
     *网络系统
     */
    network = "";

    /**
     *排污处理
     */
    sewageTreatment = "";

    /**
     *绿化程度
     */
    greeningDegree = "";

    /**
     *停车设施
     */
    parkingFacilities = "";

    /**
     *教育设施
     */
    educationFacility = "";

    /**
     *医疗设施
     */
    medicalCenter = "";

    /**
     *环卫设施
     */
    generalSanitation = "";

    /**
     *娱乐设施
     */
    entertainment = "";

    /**
     *饮食
     */
    diet = "";

    /**
     *商业服务设施
     */
    commercialService = "";

    /**
     *政府机关
     */
    governmentAgencies = "";

    /**
     *房屋配置
     */
    housingConfiguration = "";
    housingConfigurationArr = []
    /**
     *房屋亮点
     */
    housingHighlights = "";
    housingHighlightsArr = []
    /**
     * 更新用户ID
     */
    updateBy = "";

    /**
     * 更新时间
     */
    updateTime = "";

    /**
     * 发布用户ID
     */
    createBy = "";

    /**
     * 创建时间
     */
    createTime = "";
}
export default DZModelOther